import React from 'react';

export default class NotFound extends React.Component {
  render() {
    return <div>
      <h1><br /><br /></h1>
      <h1 className='text-center'>Not Found</h1>
    </div>;
  }
}
